// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"6ae3f14b","49":"f0a57710","177":"940fc81d","282":"3584600e","437":"4bfb7f60","453":"03346f77","831":"5f04f14f","898":"ad8db458","920":"3360e47e","967":"4b1e2680"}[chunkId] + ".chunk.js";
};